var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

module.exports = function Type(key, id, min, max) {
  "use strict";

  _classCallCheck(this, Type);

  this.key = key;
  this.id = id;
  this.min = min;
  this.max = max;
};